export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13815.481d8beb.jpg";